/** SUNTRONIX APPROVED ICON FAMILY — one drawing language: 24-grid, 1.6 stroke, round caps/joins, 1.5–2.5 corner radius, outline only. */
const R = (x, y, w, h, r = 2) => ({ t: "rect", x, y, w, h, r });
const C = (cx, cy, r) => ({ t: "circle", cx, cy, r });
const P = (d) => ({ t: "path", d });
const DOC = "M14 2.8H6.5A1.5 1.5 0 0 0 5 4.3v15.4a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5V7.8z M14 2.8v5h5";
const SHIELD = "M12 2.8 19.5 5.5v6c0 4.6-3.2 8.2-7.5 9.7-4.3-1.5-7.5-5.1-7.5-9.7v-6z";

export const SX_ICONS = {
  // TECHNOLOGY
  laptop: [R(4, 5, 16, 11), P("M2 19.5h20")],
  desktop: [R(3, 4, 18, 12), P("M9 20.5h6 M12 16v4.5")],
  workstation: [R(2, 5, 13, 9), P("M6 18.5h5 M8.5 14v4.5 M19.5 8h.01 M18 12h3"), R(17, 4, 5, 16, 1.5)],
  tablet: [R(5, 2.5, 14, 19, 2.5), P("M11 18.5h2")],
  smartphone: [R(7, 2.5, 10, 19, 2.5), P("M11 18.5h2")],
  monitor: [R(2.5, 4, 19, 12.5), P("M8 20.5h8 M12 16.5v4")],
  printer: [P("M7 9V3.5h10V9 M7 14h10v6.5H7z M17.5 11.5h.01"), R(3, 9, 18, 8)],
  server: [R(4, 3.5, 16, 7), R(4, 13.5, 16, 7), P("M8 7h.01 M8 17h.01 M12 7h4 M12 17h4")],
  storage: [P("M5 6c0-1.5 3.1-2.8 7-2.8s7 1.3 7 2.8-3.1 2.8-7 2.8S5 7.5 5 6z M5 6v12c0 1.5 3.1 2.8 7 2.8s7-1.3 7-2.8V6 M5 12c0 1.5 3.1 2.8 7 2.8s7-1.3 7-2.8")],
  networking: [R(9, 2.5, 6, 5, 1.5), R(2.5, 16.5, 6, 5, 1.5), R(15.5, 16.5, 6, 5, 1.5), P("M12 7.5V12 M5.5 16.5V12h13v4.5")],
  keyboard: [R(2, 6.5, 20, 11), P("M6 10.5h.01 M10 10.5h.01 M14 10.5h.01 M18 10.5h.01 M7 14h10")],
  mouse: [R(7, 3, 10, 18, 5), P("M12 3v5.5")],
  headset: [P("M4 14v-2a8 8 0 0 1 16 0v2 M19 20a3 3 0 0 1-3 2.2h-2.5"), R(3, 14, 4, 6, 1.5), R(17, 14, 4, 6, 1.5)],
  dock: [R(3, 13, 18, 6), P("M7 13V9.5A1.5 1.5 0 0 1 8.5 8h7A1.5 1.5 0 0 1 17 9.5V13 M7 16h.01 M10 16h4")],
  accessories: [P("M7 3v4 M11 3v4 M9 12v3a4 4 0 0 0 4 4h3a3 3 0 0 0 3-3V5"), R(5, 7, 8, 5, 1.5)],
  // PROCUREMENT
  product: [P("M12 2.8 20 7v10l-8 4.2L4 17V7z M4 7l8 4.2L20 7 M12 11.2v10")],
  catalogue: [P("M4 19.5V4.5A1.5 1.5 0 0 1 5.5 3H19v15H5.5A1.5 1.5 0 0 0 4 19.5zm0 0A1.5 1.5 0 0 0 5.5 21H19v-3 M8 7.5h7 M8 11h5")],
  quote: [P(DOC), P("M8.5 12.5h7 M8.5 16h4.5")],
  purchase_order: [P(DOC), P("M9 14.5l2 2 4-4")],
  cart: [P("M3 4h2.2l2.3 11h10.3l2-7.5H6.4"), C(9.5, 19.3, 1.3), C(17, 19.3, 1.3)],
  // DEPLOYMENT
  configuration: [P("M4 7h9 M17 7h3 M4 17h3 M11 17h9"), C(15, 7, 2), C(9, 17, 2)],
  employee: [C(12, 8, 3.6), P("M5 20.5a7 7 0 0 1 14 0")],
  location: [P("M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11z"), C(12, 10, 2.3)],
  mdm: [R(5, 2.5, 9, 15, 2), P("M8.8 14.5h1.4 M17.5 13.5v1 M17.5 20.5v1 M13.5 17.5h1 M20.5 17.5h1"), C(17.5, 17.5, 2.6)],
  asset_tag: [P("M3 12.2V4.5A1.5 1.5 0 0 1 4.5 3h7.7l8.6 8.6a1.5 1.5 0 0 1 0 2.1l-7.2 7.2a1.5 1.5 0 0 1-2.1 0z"), C(7.8, 7.8, 1.4)],
  serial: [R(3, 6, 18, 12), P("M7 10.5h1.5 M7 13.5h1.5 M11 10.5h6 M11 13.5h4")],
  // LOGISTICS
  warehouse: [P("M3 20.5V9l9-5.5L21 9v11.5 M7 20.5v-7h10v7 M7 17h10")],
  box: [P("M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5z M3.5 7.5 12 12l8.5-4.5 M12 12v9 M7.8 5.2l8.4 4.5")],
  courier: [R(8, 7, 13, 11, 1.5), P("M14.5 7v4 M2 10h4 M3 13.5h3 M4 17h2")],
  truck: [R(2.5, 6.5, 11, 10, 1.5), P("M13.5 10h4l3 3.2v3.3h-7"), C(7, 17.8, 1.8), C(17, 17.8, 1.8)],
  barcode: [P("M4 5v14 M6.5 5v14 M10 5v14 M12.5 5v14 M16 5v14 M18 5v14 M20 5v14")],
  qr: [R(3.5, 3.5, 6, 6, 1), R(14.5, 3.5, 6, 6, 1), R(3.5, 14.5, 6, 6, 1), P("M14.5 14.5H17V17 M20.5 14.5h.01 M14.5 20.5h.01 M18 18h2.5v2.5")],
  rack: [P("M4 2.5v19 M20 2.5v19 M4 7.5h16 M4 13h16 M4 18.5h16 M7.5 5h3 M13 10.5h4 M7.5 16h5")],
  // LIFECYCLE
  recover: [P("M3.5 12a8.5 8.5 0 1 0 2.5-6 M3.5 4v4.5H8"), R(9, 9, 6, 6, 1)],
  inspect: [C(10.5, 10.5, 6), P("M15 15l5.5 5.5 M8 10.5l1.8 1.8 3.2-3.4")],
  data_wipe: [R(3, 6, 18, 12), P("M7 12h.01 M11 10l4 4 M15 10l-4 4")],
  repair: [P("M14.7 6.3a4 4 0 0 0-5.3 5.3L3.5 17.5a2 2 0 0 0 2.9 2.9l5.9-5.9a4 4 0 0 0 5.3-5.3l-2.6 2.6-2.4-.5-.5-2.4z")],
  store: [R(3, 4, 18, 5, 1.5), P("M5 9v9.5A1.5 1.5 0 0 0 6.5 20h11a1.5 1.5 0 0 0 1.5-1.5V9 M10 13h4")],
  redeploy: [R(2.5, 5, 12, 9, 1.5), P("M6 18h5 M16 10h5.5 M19 7l2.5 3-2.5 3")],
  buyback: [C(12, 12, 8.5), P("M14.5 9.2a2.6 2.6 0 0 0-2.5-1.4c-1.5 0-2.6.8-2.6 2s1.1 1.6 2.6 2 2.6.9 2.6 2.1-1.2 2-2.6 2a2.7 2.7 0 0 1-2.6-1.5 M12 6.3v1.5 M12 16.2v1.5")],
  recycle: [P("M20 12a8 8 0 0 1-13.7 5.6 M4 12a8 8 0 0 1 13.7-5.6 M17.7 2.8v3.8h-3.8 M6.3 21.2v-3.8h3.8 M12 9v6 M9 12h6")],
  destroy: [R(3, 4, 18, 7, 1.5), P("M6 11v8 M9 11v6 M12 11v9 M15 11v6 M18 11v8")],
  // SUPPORT
  service: [C(12, 12, 3), C(12, 12, 6.8), P("M12 2.8v2.4 M12 18.8v2.4 M2.8 12h2.4 M18.8 12h2.4 M5.5 5.5l1.7 1.7 M16.8 16.8l1.7 1.7 M5.5 18.5l1.7-1.7 M16.8 7.2l1.7-1.7")],
  warranty: [P(SHIELD), P("M8.8 12l2.2 2.2 4.3-4.4")],
  help: [C(12, 12, 9), P("M9.5 9.3a2.6 2.6 0 0 1 5 .9c0 1.7-2.5 2.3-2.5 3.8 M12 17h.01")],
  shield: [P(SHIELD)],
};

export const SX_GROUPS = {
  Technology: ["laptop", "desktop", "workstation", "tablet", "smartphone", "monitor", "printer", "server", "storage", "networking", "keyboard", "mouse", "headset", "dock", "accessories"],
  Procurement: ["product", "catalogue", "quote", "purchase_order", "cart"],
  Deployment: ["configuration", "employee", "location", "mdm", "asset_tag", "serial"],
  Logistics: ["warehouse", "box", "courier", "truck", "barcode", "qr", "rack", "location"],
  Lifecycle: ["recover", "inspect", "data_wipe", "repair", "store", "redeploy", "buyback", "recycle", "destroy"],
  Support: ["service", "warranty", "help", "headset", "shield"],
};

export function SxShapes({ name }) {
  return (SX_ICONS[name] || SX_ICONS.laptop).map((s, i) => s.t === "rect" ? <rect key={i} x={s.x} y={s.y} width={s.w} height={s.h} rx={s.r} />
    : s.t === "circle" ? <circle key={i} cx={s.cx} cy={s.cy} r={s.r} /> : <path key={i} d={s.d} />);
}

/** Approved SUNTRONIX icon. Decorative by default (aria-hidden); pass `title` to make it meaningful. */
export function SxIcon({ name, size = 20, stroke = 1.6, className = "", title, ...rest }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round" className={className}
      aria-hidden={title ? undefined : true} role={title ? "img" : undefined} focusable="false" {...rest}>
      {title && <title>{title}</title>}
      <SxShapes name={name} />
    </svg>
  );
}
